import { Image, UIText1, UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SuggestItem.css';
import historyIconSrc from './assets/clock.svg';
import { ISuggestion } from '../../types/suggestions';

interface ISuggestItemProps {
  suggest: ISuggestion;
}

export const SuggestItem: React.FC<ISuggestItemProps> = ({ suggest }) => {
  return (
    <div className={styles['item']}>
      <div className={styles['icon-block']}>
        {suggest.icon ? (
          <Image
            src={suggest.icon}
            width={24}
            height={24}
            preloader={false}
            borderRadius="0"
            data-name="suggest_image"
          />
        ) : (
          <Image
            src={historyIconSrc}
            width={24}
            height={24}
            preloader={false}
            borderRadius="0"
            data-name="suggest_image"
          />
        )}
      </div>
      <div className={styles['text-block']}>
        <div className={styles['label']}>
          <UIText1>{suggest.query}</UIText1>
        </div>
        <UIText3 color="text-secondary-default">{suggest.geo}</UIText3>
      </div>
    </div>
  );
};
